import { Perk } from "../Types/Perk";

/** Shared perks for VIP and Deluxe tiers. Update this list to change both. */
export const vipPerks: Perk[] = [
  { name: "Commemorative Wristband", value: 0 },
  { name: "Unlimited Fest Re-Entry Privileges", value: 0 },
  { name: "Dedicated VIP entrance for expedited entry into the festival", value: 0 },
  { name: "Unlimited Access to the dedicated lounge(s)", value: 0 },
  { name: "Air-Conditioned, Flushable Restrooms + dedicated banks of trusty porta potties", value: 0 },
  { name: "Dedicated Food and Bar options exclusive to the VIP Lounge", value: 0 },
  { name: "Private Lockers w/charging capabilities for purchase in VIP area", value: 0 },
  { name: "Access to exclusive vendors such as massage therapists and hairstylists!", value: 0 }
];

export const deluxePerks: Perk[] = [
  { name: "Complimentary Snacks", value: 0 },
  { name: "Cell Phone Charging Area", value: 0 },
  { name: "Free Wi-Fi", value: 0 },
  { name: "Personal Guest Services", value: 0 },
  { name: "Private Lockers for purchase in Deluxe area", value: 0 },
  { name: "Access to both VIP and Deluxe Areas", value: 0 },
  { name: "Viewing areas at main stages", value: 0 },
  { name: "Plush, Cozy, Shaded Lounge", value: 0 },
  { name: "Fully stocked open Bar in Deluxe Lounge", value: 0 },
];

const deluxePlusExtraPerks: Perk[] = [ 
  { name: "Elevated platform viewing areas of the main stage", value: 0 },
  { name: "Fully-Stocked open bar exclusive to Deluxe+ Lounge", value: 0 },
  { name: "Luxury Experience with upscale seating and shaded areas", value: 0 },
  { name: "Daily catered meals (vegan options available)", value: 0 },
  { name: "Dedicated Riot Fest Merch Service (Have them do your shopping for you!)", value: 0 },
  { name: "Access to the Deluxe+ Lounge", value: 0 },
  { name: "Complimentary massage therapist in the Lounge", value: 0 }
];

export function buildVipPerks(): Perk[] {
  return [...vipPerks];
}

export function buildDeluxePerks(): Perk[] {
  return [...deluxePerks];
}

export function buildDeluxePlusPerks(): Perk[] {
  return [...deluxePlusExtraPerks];
}
